import React from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import "./RadioSelect.scss";

const propTypes = {
  /**
   * Options containing value and label.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      label: PropTypes.node.isRequired,
      disabled: PropTypes.bool,
      checked: PropTypes.bool,
    })
  ),
  /**
   * group name radio items
   */
  name: PropTypes.string.isRequired,
  /**
   * Callback for when the radio gets selected
   */
  onSelect: PropTypes.func.isRequired,
};

const defaultProps = {
  options: [],
};

/**
 * Single select radio list
 * Based on https://react-bootstrap.github.io/forms/checks-radios/.
 */
function RadioSelect(props) {
  const { options, name, onSelect } = props;

  return (
    <div>
      {options.map(({ value, label, disabled, checked }) => (
        <Form.Check
          key={value}
          checked={checked}
          onChange={(event) => onSelect(value, event)}
          type="radio"
          name={name}
          disabled={disabled}
          id={value}
          label={label}
        />
      ))}
    </div>
  );
}

RadioSelect.propTypes = propTypes;
RadioSelect.defaultProps = defaultProps;

export default RadioSelect;
